export const Lang = {
    FR: 'fr',
    EN: 'en',
};
